import firebase from 'firebase/app';
import 'firebase/firestore';

try{
    const config = {
        apiKey: "AIzaSyADcvo7ZDHqCrcrh4eiQaY_IDYjBPdHrRA",
        authDomain: "springshotel.firebaseapp.com",
        databaseURL: "https://springshotel.firebaseio.com",
        projectId: "springshotel",
        storageBucket: "springshotel.appspot.com",
        messagingSenderId: "106537299507"
    }
    firebase.initializeApp(config)
}catch (error) {
    if(!/already exists/.test(error.message)){
        console.log(`Firebase didn't initialize correctly : ${error.message}`)
    }
}
export default firebase